
new Vue({
    el: "#header",
    data() {
        return {
            navData: [
                [
                    {
                        name: 'XLIM PRO 4',
                        flag:'Anti-Burn Tech',
                        url: '/xlim-pro-4',
                        img: 'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/XLIM_PRO_4.avif?v=1791886086'
                    },
                    {
                        name: 'XLIM 4',
                        flag:'3-Level Power',
                        url: '/xlim-4',
                        img: 'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/XLIM-4.avif?v=1790650860'
                    },
                    {
                        name:'VPRIME 2',
                        flag:'60W Dual Mesh',
                        url:'/vprime-2',
                        img:'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/VPRIME_2_c367ac44-582f-4166-9249-f508d689b6ed.avif?v=1788922819'
                    },
                    {
                        name: 'NeXLIM 2',
                        flag:'Dual Mesh',
                        url: '/nexlim-2',
                        img: 'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/NeXLIM_2_1_9c563d19-9a96-4e85-805a-84d830755ab3.avif?v=1785382754'
                    }
                ],
                [
                    {
                        name: 'XLIM PRO 4',
                        flag:'Anti-Burn Tech',
                        url: '/xlim-pro-4',
                        img: 'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/XLIM_PRO_4.avif?v=1791886086'
                    },
                    {
                        name: 'XLIM 4',
                        flag:'3-Level Power',
                        url: '/xlim-4',
                        img: 'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/XLIM-4.avif?v=1790650860'
                    },
                    {
                        name: 'XLIM GO LITE',
                        flag:'3 ML New',
                        url: '/xlim-go-lite',
                        img: 'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/XLIM_GO_LITE_1a1f15cd-3786-4472-8926-24f208f7a4b0.avif?v=1780020602'
                    },
                    {
                        name: 'XLIM 3 ULTRA',
                        flag:'Touch Screen',
                        url: '/xlim-3-ultra',
                        img: 'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/XLIM_3_ULTRA_new_awards.avif?v=1786349042'
                    }
                ],
                [
                    
                    {
                        name: 'NeXLIM 2',
                        flag:'Dual Mesh',
                        url: '/nexlim-2',
                        img: 'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/NeXLIM_2_1_9c563d19-9a96-4e85-805a-84d830755ab3.avif?v=1785382754'
                    },
                    
                    {
                        name: 'NeXLIM 2 MINI',
                        flag:'Dual Mesh',
                        url: '/nexlim-2-mini',
                        img: 'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/NeXLIM_2_MINI.avif?v=1782444338'
                    },
                    {
                        name: 'NeXLIM GO',
                        flag:'Dual Mesh',
                        url: '/nexlim-go',
                        img: 'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/NeXLIM_GO_dabbe1ef-6576-440d-a87a-c57fb2e2c96d.avif?v=1789009088'
                    },
                    {
                        name: 'NeXLIM',
                        flag:'Dual Mesh',
                        url: '/nexlim',
                        img: 'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/NeXLIM_84119bc5-30f2-428b-87fa-b103204e6944.avif?v=1765942847'
                    }
                ],
                [
                    {
                        name:'VPRIME 2',
                        flag:'60W Dual Mesh',
                        url:'/vprime-2',
                        img:'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/VPRIME_2_c367ac44-582f-4166-9249-f508d689b6ed.avif?v=1788922819'
                    },
                    {
                        name:'VPRIME',
                        flag:'60W Pod',
                        url:'/vprime',
                        img:'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/VPRIME_2d17c000-c575-44b2-990a-5054170d87fb.avif?v=1765943503'
                    }
                ],
                [
                    {
                        name: 'SLIMSTICK NANO',
                        flag:'Pen Style',
                        url: '/slimstick-nano',
                        img: 'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/Slimstick_Nano.avif?v=1789434820'
                    },
                    {
                        name: 'SLIMSTICK',
                        flag:'Prefilled',
                        url: '/slimstick',
                        img: 'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/SLIMSTICK_awards.avif?v=1767754813'
                    },
                    {
                        name:'ONEO PRO',
                        flag:'40W & Screen',
                        url:'/oneo-pro',
                        img:'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/ONEO-PRO_1.avif?v=1783474058'
                    },
                    {
                        name:'UNIONE',
                        flag:'10 ML Mega Pod',
                        url:'/unione',
                        img:'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/UNIONE.avif?v=1778635492'
                    }
                ],
                [
                    {
                        name: 'XLIM ABT CARTRIDGE<br> UNITECH 3.0',
                        flag:'Anti-Burn Tech',
                        url: '/xlim-pro-4',
                        img: 'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/XLIM_ABT_Cartridge.avif?v=1791886086'
                    },
                    {
                        name: 'XLIM TOP FILL CARTRIDGE<br> UNITECH 3.0',
                        flag:'Upgrade',
                        url: '/xlim-top-fill-cartridge-unitech-3',
                        img: 'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/XLIM_4_Cartridge_UNITECH_3.0.avif?v=1789438848'
                    },
                    {
                        name: 'VPRIME Dual Mesh<br> Cartridge',
                        flag:'6ML/2ML',
                        url: '/vprime-2',
                        img: 'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/VPRIME_Dual_Mesh_Cartridge.avif?v=1788921460'
                    },
                    {
                        name: 'NeXLIM CARTRIDGE<br> UNITECH 3.0',
                        flag:'4ML/2ML',
                        url: '/nexlim-cartridge-unitech3',
                        img: 'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/NeXLIM_CARTRIDGE_V2.avif?v=1782467421'
                    }
                ]
            ],
            navTitle:['New Arrival','XLIM Series','NeXLIM Series','VPRIME Series','Others','Platform'],
            homeFlag:false,
            navIndex:0,
            arr:productsData,
            keyword:'',
            resData:[]
        }
    },
    computed: {
        flatData() {
          return this.arr.flat()
        }
    },
    methods:{
        normalize(val) {
            return (val || "")
            .toString()
            .toLowerCase()
            .trim()
            .replace(/\s*/g, "");
        },
        
        downloadSearch(value) {
            const vStr = this.normalize(value);
            
            this.resData.length=0

            this.flatData.forEach(item => {
                const str = this.normalize(item.title);
                
                if (str.indexOf(vStr) !== -1) {
                    this.resData.push(item)
                }
            })

            //no result
            if (this.resData.length==0) {
                showMessage("Sorry, no result", "error");
                this.keyword = "";
                this.resData.length=0
            }
        },
        submitI() {
            const val = this.keyword;
            if (val) this.downloadSearch(val);
        },
        onSearchClick() {
            const val = this.keyword;
            if (val) {
                this.downloadSearch(val);
            } else {
                this.resData.length=0
            }
        },
        onFocus() {
            this.resData.length=0
        }
    },
    created(){
        if (document.querySelector('.homePage_flag')) {
            this.homeFlag = true
        }
    },
    mounted(){
        //导航栏悬停
        $(".item").hover(function () {
            var index = $(this).parent().index();
            $(this).css({color:'red'})
            //$(this).children('.item_line').css({ 'width': '100%', 'transition': 'width 0.5s linear' })
            if (index != 5) {
                $(`.main_popup${index + 1}`).css({ height: eval(`$('.main_popup${index + 1}')[0].scrollHeight`) })
                $('.main_mask').css({ height: '96vh' })
            }
        }, function () {
            //$(this).children('.item_line').css({ 'width': '0px', 'transition': 'width 0s' });
            var index = $(this).parent().index();
            $(this).css({color:'black'})
            if (index != 5) {
                $(`.main_popup${index + 1}`).css({ "height": "0" })
                $('.main_mask').css({ height: '0' })
            }
        })

        //导航窗悬停
        $(".main_popup").hover(function () {
            var index = $(this).index() + 1
            $(this).css({ height: eval(`$('.main_popup${index}')[0].scrollHeight`) })
            //$(`.itemHref:nth-child(${index}) .item`).children('.item_line').css({ 'width': '100%' });
            $(`.itemHref:nth-child(${index}) .item`).css({color:'red'})
            $('.main_mask').css({ height: '96vh' })
        }, function () {
            var index = $(this).index() + 1
            //$(`.itemHref:nth-child(${index}) .item`).children('.item_line').css({ 'width': '0%' });
            $(`.itemHref:nth-child(${index}) .item`).css({color:'black'})
            $(this).css({ height: '0' })
            $('.main_mask').css({ height: '0' })
        })
    }
})


$(() => {
    // 如果当前是 /id 路径，直接返回，不去覆盖印尼站逻辑
    if (window.location.pathname.indexOf('/id') !== -1) {
        return;
    }

    // 欧洲国家列表
    var euCountries = [
        'AT', 'BE', 'BG', 'HR', 'CY', 'CZ', 'DK', 'EE', 'FI', 'FR',
        'DE', 'GR', 'HU', 'IE', 'IT', 'LV', 'LT', 'LU', 'MT', 'NL',
        'PL', 'PT', 'RO', 'SK', 'SI', 'ES', 'SE'
    ];

    var cached = getCookie('user_country');
    
    if(cached){
        handleCountry(cached);
    }

    // 根据国家码处理链接
    function handleCountry(code) {
        if (euCountries.indexOf(code) !== -1) {
            var link = document.querySelector('.nav_store');
            if (link) {
                link.href = 'https://oxvaeu.com/';
            }
        }
    }
})


var wFlag = window.innerWidth>750
$(()=>{
    if(wFlag){
        $('.nav_search').hover(function(){
            $(`.searchPopup`).css({ height: eval(`$('.searchPopup')[0].scrollHeight`) })
            $('.main_mask').css({ height: '96vh' })
        },function(){
            $(`.searchPopup`).css({ "height": "0" })
            $('.main_mask').css({ height: '0' })
        })

        $(`.searchPopup`).hover(function(){
            $(this).css({ height: eval(`$('.searchPopup')[0].scrollHeight`) })
            $('.main_mask').css({ height: '96vh' })
        },function(){
            $(this).css({ "height": "0" })
            $('.main_mask').css({ height: '0' })
        })
    }else{//mobile left icon
        var mliflag = true;
        $('.menu_left').click(function () {
            if (mliflag) {
                $('.menu_line').css({ background: 'transparent' })
                $(this).addClass('menu_active')
                $('.Mmenu').css({ height: '96vh', transition: 'all 1s' })
                mliflag = !mliflag
            } else {
                $('.menu_line').css({ background: 'black' })
                $(this).removeClass('menu_active')
                $('.Mmenu').css({ height: '0', transition: 'all 1s' })
                mliflag = !mliflag
            }
        })
        
        $('.mit_flag.Mmenu_item').click(function () {
            var index = $(this).index()
            var Hmheight = $(this).next('.Mm_popup').css('height')
            if (Hmheight == '0px') {
                $(this).children('.Mm_icon').css({ transform: 'rotate(90deg)' })
                $(this).next('.Mm_popup').css({ height: eval(`$(this).next('.Mm_popup')[0].scrollHeight`) })
                //products
                if (index == 0) {
                    setTimeout(() => {
                        $(this).next('.Mm_popup').css({ height: 'auto' })
                    }, 500);
                }
            } else {
                $(this).children('.Mm_icon').css({ transform: 'rotate(0)' })
                if (index == 0) {
                    $(this).next('.Mm_popup').css({ height: eval(`$(this).next('.Mm_popup')[0].scrollHeight`) })
                    setTimeout(() => {
                        $(this).next('.Mm_popup').css({ height: '0' })
                    }, 100);
                } else {
                    $(this).next('.Mm_popup').css({ height: '0' })
                }
            }
        })
        
        $('.series').click(function () {
            var Toheight = $(this).next('.Ms_content')[0].scrollHeight
            var height = $(this).next('.Ms_content').css('height')
            if (height == '0px') {
                $(this).children('.series_right').addClass('Ms_active')
                $(this).next('.Ms_content').css({ height: `${Toheight}px` })
            } else {
                $(this).children('.series_right').removeClass('Ms_active')
                $(this).next('.Ms_content').css({ height: '0' })
            }
        })
        
        var mliflag1 = true;
        $('.Mnav_search').click(function(){
            if(mliflag1){
                $('.searchPopup').css({ height: '96vh'})
            }else{
                $('.searchPopup').css({ height: '0'})
            }
            mliflag1 = !mliflag1
        })
    }
})

//页头固定
var lastScrollTop = 0, homeFlag = false
$(function () {
    if (document.querySelector('.homePage_flag')) {
        homeFlag = true
    }
})

$(window).scroll(function () {
    var Top = $(window).scrollTop()
    if (Top > 84) {
        //购买导航栏
        $('.product_nav').css({ top: '0', transition: 'all 1s' })
        $('.Mproduct_nav').css({ top: '0', transition: 'all 1s' })

        $('.main_header').css({ position: "fixed", zIndex: "22", width: "100%", left: "0"})
        $('.main_Mheader').css({ position: "fixed", top: "0", zIndex: "22", width: "100%", left: "0" })

    } else {
        $('.product_nav').css({ top: '-3.75rem', transition: 'none' })
        $('.Mproduct_nav').css({ top: '-3.75rem', transition: 'none' })

        $('.main_header').css({ position: "absolute" })
        $('.main_Mheader').css({ position: "absolute" })
    }

    // 置顶视频 
    // if(homeFlag){
    //     if(Top>window.innerHeight){
    //         $('.main_header').css({position:"fixed",zIndex:"22",width:"100%",left:"0",background:'black'})
    //         $('.items').css({color:'white'})

    //         $('.main_Mheader').css({position:"fixed",top:"0",zIndex:"22",width:"100%",left:"0"})
    //     }else{
    //         $('.main_header').css({position:"absolute",background:'transparent'})

    //         $('.main_Mheader').css({position:"absolute"})
    //     }
    // }

    if (Top < lastScrollTop) {
        // 鼠标向上滑动
        if (Top > 1) {
            $('.To_top').fadeIn()
        } else {
            $('.To_top').fadeOut();
        }
    } else {
        $('.To_top').fadeOut();
    }
    lastScrollTop = Top;
})



//俄语样式修改
if (window.location.href.includes('ru')) {
    $('.nav').css({ width: '50%' })
}

$('.home_video video').click(function () {
    var element = $('.home_video video')[0]
    if (window.innerWidth < 750) {
        var element = $('.home_video video')[1]
    }
    if (element.requestFullscreen) {
        element.requestFullscreen()
    }
})